/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const CreateChatInvitationResponse = zod.object({
  invitation: zod.object({
    displayTarget: zod.string().describe('Echoes what the caller typed; never a resolved value'),
    expiresAt: zod.iso
      .datetime({ offset: true })
      .describe(
        'Issue-time expiry: 7 days for identifier invitations, 180 days for actor invitations',
      ),
    status: zod.enum(['open']),
    uuid: zod.uuid().describe("Core's invitation ledger id"),
  }),
});

export type CreateChatInvitationResponse = zod.input<typeof CreateChatInvitationResponse>;
export type CreateChatInvitationResponseOutput = zod.output<typeof CreateChatInvitationResponse>;
